import React, { Component } from 'react';
import { connect } from 'react-redux';
import HereMapWithMarker from './HereMapWithMarker';
class DeliveryDetailsMap extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const props = this.props;

		return (
			<div className="row division pt-0 mt-0">
				<div style={{ width: "100%" }}>
					<div className="here-maps" style={{ height: `450px`, width: `100%` }}>
						<HereMapWithMarker latitude={props.latitude} longitude={props.longitude} deliveryConfig={props.deliveryConfig} />
					</div>
				</div>
			</div>
		)
	}
}

DeliveryDetailsMap.contextTypes = {

};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDetailsMap);
